module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 75
// module chunks = 0